<!-- SESSION WARNING POPUP (END) -->
<div class="modal fade" id="mdlTimeoutWarning" role="dialog">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onSessionExtended()">
                    <span aria-hidden="true"><i class="fas fa-times"></i></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="rde-container-fluid">
                    <div class="rde-row">
                        <div class="col-12 text-center">
                            <i class="fal fa-clock accent-icon pb-3" style="color:#eaaa00"></i>
                        </div>
                        <div class="col-12 text-center pb-4">
                            <h3 class="text-center font-14" *ngIf="!isSessionTimedOut">Your session is about to end.</h3>
                            <h3 class="text-center font-14" *ngIf="isSessionTimedOut">Your session has expired. Signing out...</h3>
                        </div>
                        <div class="col-12 text-center font-14" *ngIf="!isSessionTimedOut">
                            Your session will expire soon due to inactivity and you will be signed out automatically
                            <span *ngIf="countdown > 0">in approximately<br />{{ countdownText }}.</span>
                            <span *ngIf="countdown <= 0">momentarily.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="!isSessionTimedOut" id="btnExtendSession" type="button" class="btn btn-primary" (click)="onSessionExtended()">Stay Signed In</button>
            </div>
        </div>
    </div>
</div>
<!-- SESSION WARNING POPUP (END) -->

<!-- LOGOUT POPUP (START) -->
<div class="modal fade" id="mdlLogout" role="dialog">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onLogoutCancelled()">
                    <span aria-hidden="true"><i class="fas fa-times"></i></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="rde-container-fluid">
                    <div class="rde-row">
                        <div class="col-12 text-center">
                            <i class="fal fa-sign-out accent-icon pb-3" style="color:#eaaa00"></i>
                        </div>
                        <div class="col-12">
                            <h3 class="text-center font-weight-bold font-14">Are you sure you want to logout?</h3>
                        </div>
                        <div class="col-12">
                            <h5 class="text-center font-14">If you have unsaved work it will be lost.</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button id="btnLogout" type="button" class="btn btn-primary" (click)="onLogoutConfirmed()">Yes, Logout</button>
                <button id="btnCancelLogout" type="button" class="btn btn-cancel" (click)="onLogoutCancelled()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- LOGOUT POPUP (END) -->